import { FormattedMessage, useIntl } from 'react-intl'

import { ButtonGroup, CardBody } from 'Components/_theme'

import { LostOrStolenModalConfirmationProps } from 'Modals/LostOrStolenModal/LostOrStolenModal.types'

import { countryISOCodes } from 'Constants/constants'
import {
  E2E_LOST_STOLEN_BUTTON_CLOSE,
  E2E_LOST_STOLEN_ORDER_ID,
} from 'Constants/e2e'

import { ReplacementType } from 'Portal/__generated__/globalTypes'

export const LostOrStolenModalConfirmation = (
  props: LostOrStolenModalConfirmationProps,
) => {
  const { selectionType, messageRef, requestIdRef, shippingFormData, onClose } =
    props
  const intl = useIntl()

  const isUnitedStatesAddressType =
    shippingFormData?.country?.value === countryISOCodes.US

  return (
    <CardBody>
      <h4 className="text-info">
        <FormattedMessage
          id={
            selectionType === ReplacementType.none ||
            selectionType === ReplacementType.everphone
              ? 'LostOrStolenModal_confirmationNoReplacement_heading'
              : 'NewOrderConfirmation_heading'
          }
        />
      </h4>

      <div className="d-flex flex-row mt-6">
        <div className="w-50">
          {shippingFormData && (
            <>
              <h6>
                <FormattedMessage id="Shipping_Address" />
              </h6>

              <p>
                {shippingFormData.name}
                <br />
                {shippingFormData.nameAddition}
                <br />
                {isUnitedStatesAddressType
                  ? shippingFormData.address
                  : `${shippingFormData.street} / ${shippingFormData.streetNumber}`}
                <br />
                {shippingFormData.zipcode} / {shippingFormData.city}
                <br />
                {shippingFormData.country?.label}
              </p>
            </>
          )}

          {requestIdRef?.current && (
            <>
              <h6 className="mt-6">
                <FormattedMessage id="NewOrderConfirmation_request_id" />
              </h6>

              <p data-e2e={E2E_LOST_STOLEN_ORDER_ID}>{requestIdRef.current}</p>
            </>
          )}
        </div>
      </div>

      {messageRef?.current && (
        <div className="mt-4">
          <h6>
            <FormattedMessage id="Message_for_everphone" />
          </h6>

          <p>{messageRef.current}</p>
        </div>
      )}

      <ButtonGroup
        rightButton={{
          'data-e2e': E2E_LOST_STOLEN_BUTTON_CLOSE,
          onClick: onClose,
          text: intl.formatMessage({ id: 'Done' }),
        }}
      />
    </CardBody>
  )
}
